import { render, staticRenderFns } from "./UiBlockRenderer.vue?vue&type=template&id=6af00114&scoped=true"
import script from "./UiBlockRenderer.vue?vue&type=script&lang=js"
export * from "./UiBlockRenderer.vue?vue&type=script&lang=js"
import style0 from "./UiBlockRenderer.vue?vue&type=style&index=0&id=6af00114&prod&scoped=true&lang=css"
import style1 from "./uiBlockShared.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af00114",
  null
  
)

export default component.exports